import {
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAIL,
  CLEAR_NOTIFICATIONS,
  LOAD_MORE_NOTIFICATIONS,
  LOAD_MORE_NOTIFICATIONS_SUCCESS,
  LOAD_MORE_NOTIFICATIONS_FAIL,
  TOGGLE_NOTIFICATION_READ_UNREAD,
  TOGGLE_NOTIFICATION_READ_UNREAD_SUCCESS,
  TOGGLE_NOTIFICATION_READ_UNREAD_FAIL,
  DELETE_NOTIFICATION,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_FAIL,
} from "./actionTypes"

// GET NOTIFICATIONS ACTIONS
export const getNotifications = (options, history) => ({
  type: GET_NOTIFICATIONS,
  payload: { options, history },
})

export const getNotificationsSuccess = notifications => ({
  type: GET_NOTIFICATIONS_SUCCESS,
  payload: notifications,
})

export const getNotificationsFail = error => ({
  type: GET_NOTIFICATIONS_FAIL,
  payload: error,
})

export const clearNotifications = () => ({
  type: CLEAR_NOTIFICATIONS,
})

// LOAD MORE NOTIFICATIONS ACTIONS
export const loadMoreNotifications = (options, history) => ({
  type: LOAD_MORE_NOTIFICATIONS,
  payload: { options, history },
})

export const loadMoreNotificationsSuccess = notifications => ({
  type: LOAD_MORE_NOTIFICATIONS_SUCCESS,
  payload: notifications,
})

export const loadMoreNotificationsFail = error => ({
  type: LOAD_MORE_NOTIFICATIONS_FAIL,
  payload: error,
})

// TOGGLE NOTIFICATION READ/UNREAD ACTIONS
export const toggleNotificationReadUnread = (notificationIDs, history) => ({
  type: TOGGLE_NOTIFICATION_READ_UNREAD,
  payload: { notificationIDs, history },
})

export const toggleNotificationReadUnreadSuccess = response => ({
  type: TOGGLE_NOTIFICATION_READ_UNREAD_SUCCESS,
  payload: response,
})

export const toggleNotificationReadUnreadFail = error => ({
  type: TOGGLE_NOTIFICATION_READ_UNREAD_FAIL,
  payload: error,
})

// DELETE NOTIFICATION ACTIONS
export const deleteNotification = (notificationIDs, history) => ({
  type: DELETE_NOTIFICATION,
  payload: { notificationIDs, history },
})

export const deleteNotificationSuccess = response => ({
  type: DELETE_NOTIFICATION_SUCCESS,
  payload: response,
})

export const deleteNotificationFail = error => ({
  type: DELETE_NOTIFICATION_FAIL,
  payload: error,
})